var map = {
	"./Rectangle-26.jpg": 45676,
	"./Rectangle-27.jpg": 937,
	"./Rectangle-28.jpg": 30130,
	"./Rectangle-29.jpg": 6511,
	"./boy-2.png": 74989,
	"./chrome.png": 9438,
	"./earning-back.jpg": 16446,
	"./firefox.png": 55609,
	"./folder.png": 35840,
	"./folder1.png": 72139,
	"./image-20.jpg": 50798,
	"./img-26.jpg": 85766,
	"./img-26.png": 49602,
	"./premium-ace.png": 83779,
	"./profile.jpg": 95917,
	"./safari.png": 80404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39834;